<template>
  <v-container fluid>
    <v-row class="flex-row justify-end mt-5">
      <a :href="route('warehouse.csv')">
        <v-btn color="primary" class="mr-4">
          CSV Export
        </v-btn>
      </a>
      <div v-if="!createPrompt">
        <v-btn color="primary" @click="createPrompt = true">
          Lager Anlegen
        </v-btn>
      </div>

      <!-- <v-col v-if="createPrompt" cols="12">
        <Warehouse @created="created" />
      </v-col> -->
    </v-row>
    <v-row flex-row>
      <v-col v-for="(warehouse, i) in warehouses" :key="i" cols="4">
        <v-hover v-slot="{ hover }">
          <v-card
            outlined
            :elevation="hover ? 16 : 2"
            :class="{ 'on-hover': 'hover' }"
            class="pa-4"
            title
          >
            <v-row>
              <v-col cols="10">
                <inertia-link :href="route('warehouse.show', warehouse.id)">
                  <v-row>
                    <v-col cols="12">
                      <b>{{ warehouse.name }} </b>
                    </v-col>
                    <v-col cols="12">
                      Lagernummer: <b>{{ warehouse.number }} </b>
                    </v-col>
                    <v-col cols="12">
                      <span>
                        Seriennummer:
                        <b>{{ warehouse.serial_number || '-' }}</b>
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <span>
                        Aktuelle Warenmenge:
                        <b>{{ warehouse.stock }}</b>
                      </span>
                    </v-col>
                  </v-row>
                </inertia-link>
              </v-col>

              <v-col cols="2">
                <v-btn text @click="edit(warehouse)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-dialog v-model="createPrompt" max-width="600">
      <CreateWarehouse @created="created" />
    </v-dialog>
    <v-dialog v-model="editPrompt" max-width="600">
      <EditWarehouse :warehouse="toEdit" @updated="updated" @close="close" />
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import CreateWarehouse from '@/Components/Admin/Warehouse/Create'
import EditWarehouse from '@/Components/Admin/Warehouse/Edit'
export default {
   components: {
      CreateWarehouse,
      EditWarehouse
   },
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Lager',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      warehouses: {
         type: Object,
         required: true,
      },
   },
   data () {
      return {
         editPrompt: false,
         createPrompt: false,
         toEdit: null
      }
   },
   methods: {
      created () {
         this.createPrompt = false
      },
      updated () {
         this.editPrompt = false
      },
      edit (warehouse) {
         this.toEdit = warehouse
         this.editPrompt = true
      },
      close () {
         this.createPrompt = false
         this.editPrompt = false
      }
   }
}
</script>

<style lang="sass" scoped>
.v-card.on-hover.theme--dark
  background-color: rgba(#FFF, 0.8)
  >.v-card__text
    color: #000
</style>
